export default __webpack_public_path__ + "static/media/zurich-color.46404b33.svg";